// extracted by mini-css-extract-plugin
module.exports = {"like":"styles_like__3RCsV","animation":"styles_animation__1ItCn"};